// extracted by mini-css-extract-plugin
module.exports = {"logo":"LogoName_logo__SBYFf"};